import mobileAdjustment from "../GeneralMobileAdjustments";

class MobilePasswordInputControlView {

    constructor() {

    }

    afterRender(control){
        let element = mobileAdjustment.adjustMobileControl(control);
        element.find("div:first").css({"line-height": "normal"});
    }
}

const mobilePasswordInputControlView = new MobilePasswordInputControlView();
export default mobilePasswordInputControlView;